export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00745.15380220.png";